import React, { useState, useEffect } from "react";
import "../css/message.css";
import Draw from "../js/draw";

export default function Message() {
  const [message, setMessage] = useState("save");

  useEffect(() => {
    let save = document.querySelector(".save_button");
    let del = document.querySelector(".delete_button");
    let message_container = document.querySelector(".message_container");

    save.addEventListener("click", saveMessage);
    del.addEventListener("click", deleteMessage);
    message_container.addEventListener("click", hideMessageBox);

    function hideMessageBox(ev) {
      if (ev.target.nodeName !== "BUTTON") return;

      message_container.classList.remove("showDialog");
    }
    function saveMessage() {
      // history is empty don't show;
      if (Draw.history.historyTest.length <= 1) return;

      setMessage("save");
      message_container.classList.add("showDialog");
    }
    function deleteMessage() {
      // history is empty don't show;
      if (Draw.history.historyTest.length <= 2) return;

      setMessage("delete");
      message_container.classList.add("showDialog");
    }

    return () => {
      save.removeEventListener("click", saveMessage);
      del.removeEventListener("click", deleteMessage);
      message_container.removeEventListener("click", hideMessageBox);
    };
  }, []);

  return (
    <div className="message_container">
      <div className="message_border">
        <div className="message">
          {message === "save" ? <Save /> : <Delete />}
        </div>
      </div>
    </div>
  );
}

function Save() {
  const clean = () => {
    Draw.history.cleanTest();
    // Common.background = undefined;

    let canvas_buttons = document.querySelectorAll(".canvasesButton");
    for (let button of canvas_buttons) {
      button.classList.remove("background_selected");
    }
  };

  return (
    <>
      <h3 className="title">Your artwork is saved</h3>
      <p className="info">Your picture has been saved to your camera roll</p>
      <div className="buttons_wrapper_save">
        <button className="message_button" onClick={clean}>
          Start a new picture
        </button>
        <button className="message_button">Continue with this one</button>
      </div>
    </>
  );
}

function Delete() {
  const clean = () => {
    Draw.history.cleanTest();
    // Common.background = undefined;

    let canvas_buttons = document.querySelectorAll(".canvasesButton");
    for (let button of canvas_buttons) {
      button.classList.remove("background_selected");
    }
  };

  return (
    <>
      <h3 className="title">Delete your artwork?</h3>
      <p className="info">All changes to your current artwork will be lost</p>
      <div className="buttons_wrapper_delete">
        <button className="message_button">No</button>
        <button className="message_button" onClick={clean}>
          Yes
        </button>
      </div>
    </>
  );
}
